import React from 'react'
import { FetchUpdateArticleType } from '../../fetcher';
import { UpdateArticleTypeView } from './UpdateArticleTypeView';

const UpdateArticleTypeContainer = ({ articleTypeDetail, handleCloseArticleType, openAlert }) => {

    /**
     * Calls fetch to update articleType with new set values
     * @param {object} articleTypeToUpdate
     */
    const handleSubmit = (articleTypeToUpdate) => {
        FetchUpdateArticleType(articleTypeToUpdate, handleCloseArticleType, openAlert)
    }

    return (
        <UpdateArticleTypeView articleType={articleTypeDetail} handleSubmit={handleSubmit} />
    )
}

export { UpdateArticleTypeContainer }